import React from 'react'
import Container from '../components/Container'
import ContactCards from '../components/Contact/ContactCards'

const AboutTheAssociationMessage = () => {
  return (
    <>
      <div>
        <h1 className="text-white font-bold text-center bg-primary py-8">الرسالة</h1>
      </div>
      <Container>
        <div className='md:mb-16 sm:w-11/12 md:w-full lg:w-11/12 mx-auto'>
          <article className='shadow-[0_4px_20px_rgba(0,0,0,0.2)] relative bg-primary px-4 py-8 md:px-10 md:py-16 -shadow-lg rounded md:w-10/12 md:mr-auto md:pr-24 md:min-h-96 md:-translate-x-12'>
            <div className="mb-8 grid gap-y-2 text-white">
              <h2 className="font-semibold text-xl">رسالة الجمعية</h2>
              <p>نعمل على تعزيز الإنماء الاجتماعي والاقتصادي وتنمية الروابط الاجتماعية بين أفراد المجتمع، من خلال تلمس احتياجات المجتمع المحلي، والتعبير عنها بوضوح، والمساهمة في تلبيتها بالشراكة مع الجهات المختصة ونسعى لتحسين واقع المجتمع المحلي من خلال دعم العمل الإيجابي، وتفعيل المشاركة المجتمعية لتحقيق التغيير المستدام.</p>
            </div>
            <div className='shadow-[0_4px_20px_rgba(0,0,0,0.2)] absolute top-100 left-1/2 -translate-x-1/2 bg-white rounded-lg overflow-hidden w-11/12 md:top-1/2 md:-translate-y-1/2 md:h-5/6 md:w-4/12 md:left-full md:-translate-x-12 md:grid md:place-items-center'>
              <img src="/images/header_original_logo.jpg" alt="logo" className=''/>
            </div>
          </article>
          <div className='invisible md:hidden'>
            <img src="/images/header_original_logo.jpg" alt="logo" />
          </div>
        </div>
        <ContactCards />
      </Container>
  </>
  )
}

export default AboutTheAssociationMessage